module.exports = __webpack_public_path__ + "img/search.d1e79930.svg";